import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, signal, SimpleChanges } from '@angular/core';
import { AbstractControl, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-error-message',
  standalone: false,
  styles: ``,
  templateUrl: './error-message.component.html',
  host: {
    'class': 'invalid-feedback'
  }
})
export class ErrorMessageComponent implements OnInit, OnDestroy {
  @Input('form') form: NgForm;
  @Input('control') controlName: string;

  protected errorMsg = signal('');
  private sub?: Subscription;

  ngOnInit(): void {
    this.refresh();
    this.sub = this.form.form.events.subscribe(() => this.refresh());
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private refresh(): void {
    const ctl = this.form?.controls?.[this.controlName];
    const e = ctl?.errors;

    if (!e) {
      this.errorMsg.set('');
      return;
    }

    // The ladder to maintain/expand — order = display priority, first match wins.
    if (e['typeaheadSelection']) {
      this.errorMsg.set('Please select an option from the list');
    } else if (e['required']) {
      this.errorMsg.set('This field is required');
    } else if (e['max']) {
      this.errorMsg.set(`This field must be no more than ${e['max'].max}`);
    } else if (e['min']) {
      this.errorMsg.set(`This field must be at least ${e['min'].min}`);
    } else if (e['decimalPlaces']) {
      this.errorMsg.set(`This field allows at most ${e['decimalPlaces'].places} decimal places`);
    } else if (e['email']) {
      this.errorMsg.set('Please provide a valid email address');
    } else if (e['mustMatch']) {
      this.errorMsg.set('Field values must match');
    } else {
      this.errorMsg.set('This field is invalid');
      console.log(e);
    }
  }
}
